var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportFromExcel02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 235.69 235.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".h,.i{fill:#fff;}.i{stroke-width:2.86px;}.i,.j,.k{stroke:#fff;stroke-miterlimit:10;}.j{stroke-linecap:round;}.j,.k{fill:none;stroke-width:5.72px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M52.57,87.54V31.81h75.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M186.89,93.26v125.74H52.57v-54.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "k",
    x: 14.02,
    y: 87.54,
    width: 77.16,
    height: 77.16,
    rx: 9.76,
    ry: 9.76
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M61.09,144.24l-4.58-7.94c-1.86-3.04-3.04-5.01-4.15-7.08h-.11c-1.01,2.08-2.02,3.99-3.89,7.14l-4.31,7.88h-5.33l10.97-18.16-10.55-17.74h5.38l4.74,8.42c1.33,2.34,2.34,4.16,3.3,6.07h.16c1.01-2.13,1.92-3.78,3.25-6.07l4.9-8.42h5.33l-10.92,17.47,11.19,18.43h-5.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 104.01,
    y: 101.83,
    width: 67.16,
    height: 5.72,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 104.01,
    y: 120.41,
    width: 67.16,
    height: 5.72,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    x: 104.01,
    y: 138.98,
    width: 67.16,
    height: 5.72,
    rx: 2,
    ry: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M147.52,80h35.83c1.52,0,2.91-.62,3.91-1.62,1-1,1.62-2.38,1.62-3.9,0-3.05-2.48-5.52-5.52-5.52h-23.87l44.52-44.52c1.08-1.08,1.62-2.5,1.62-3.91,0-1.41-.54-2.83-1.62-3.91-2.16-2.16-5.65-2.16-7.81,0l-44.6,44.6v-24.01c0-3.05-2.48-5.52-5.52-5.52-1.52,0-2.91,.62-3.91,1.61-1,1-1.62,2.39-1.62,3.91v37.44c0,.08,0,.16,.01,.23,0,0,0,0,0,.01t0,0c0,.18,.02,.35,.04,.51,0,.09,.02,.18,.04,.25s.03,.16,.05,.24c0,.09,.03,.17,.06,.24,.02,.07,.04,.14,.06,.21,.06,.19,.12,.37,.21,.54,.06,.14,.13,.27,.2,.4,0,0,0,.01,.01,.02,.05,.1,.11,.2,.17,.29,.02,.04,.05,.09,.09,.14,.08,.12,.16,.23,.25,.34,.1,.13,.21,.26,.34,.39,.98,.95,2.33,1.53,3.82,1.53h1.48s.06-.01,.09-.02l.03,.02Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "g"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportFromExcel02);
export default __webpack_public_path__ + "static/media/Import_From_excel-02.c7d37c1ae69d24d9ef03fc1adfd6f498.svg";
export { ForwardRef as ReactComponent };